/**
 * The `type` marking a source as Medicare, which is the one source owing the
 * reader a CMS Blue Button disclosure before any handoff to it.
 */
export const MEDICARE_SOURCE_TYPE = "medicare";

/**
 * FHIR source representing a healthcare organization's patient portal
 */
export interface FhirSource {
    id: string;
    name: string;
    fhirBaseUrl: string;
    logo: string | null;
    type: string | null;
    portalUrl: string | null;
}

/**
 * Possible patient portal recommendation for a user
 */
export interface PossiblePortal {
    id: number;
    source: string;
    fhirBaseUrl: string;
    name: string;
    logo: string | null;
    type: string;
    portalUrl: string | null;
}
